import { Badge, Button } from "@mantine/core";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { v5 as uuidv5 } from "uuid";

import moment from "moment";
import toast from "react-hot-toast";
import { FaPlug } from "react-icons/fa";
import {
  ApiCrearTicket,
  ApiGetAllTicketsWithDate,
  ApiGetTotalTicketWithDates,
} from "../../api/tickets";
import imagecheck from "../../assets/check.png";
import BirthdayFireworksCanvas from "../../components/BirthdayGlobos/BirthdayFireworksCanvas";
import ModalDefault from "../../components/modalDefault";
import NumericKeyboard from "../../components/NumericKeyboard";
import { socket } from "../../config/socket";
import { dateLocal } from "../../utils/date";

const UUID_NAMESPACE = "1b671a64-40d5-491e-99b0-da01ff1f3341";
const SteperTickets = ({
  user,
  setUser,
  active,
  setActive,
  nextStep,
  prevStep,
  periodo,
  isOnline,
  open,
  nominausuarios,
  setErrorMessage,
  handleGetPeriodo,
  handleGetNomina,
}) => {
  const inputRef = useRef(null);

  const [userCode, setUserCode] = useState("");
  const [loadingStep1, setLoadingStep1] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [timer, setTimer] = useState(null);
  const [periodoActual, setPeriodoActual] = useState(null);
  const [datatickets, setdatatickets] = useState([]);
  const [showKeyboard, setShowKeyboard] = useState(true);
  const [birthday, setBirthday] = useState([]);

  const onClosedModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    init();
    // const interval = setInterval(() => {
    //   init();
    // }, 3000);

    // return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const periodoFind = getPeriodoActual();
    setPeriodoActual(periodoFind);
  }, [timer]);

  const getPeriodoActual = () => {
    if (!periodo?.pre_comidas_periodo?.length) return null;

    const now = dayjs();
    for (const item of periodo.pre_comidas_periodo) {
      const { hora_inicio, hora_fin } = item.pre_comidas;
      const start = dayjs(`${now.format("YYYY-MM-DD")} ${hora_inicio}`);
      const end = dayjs(`${now.format("YYYY-MM-DD")} ${hora_fin}`);
      const endCorrected = end.isBefore(start) ? end.add(1, "day") : end;

      if (now.isAfter(start) && now.isBefore(endCorrected)) {
        return item;
      }
    }
    return null;
  };

  // Socket Handling
  useEffect(() => {
    // Conectar
    //socket.connect();
    if (!socket.connected) {
      socket.connect();
    }

    const handleTicketUpdate = async (item) => {
      console.warn("Ticket update received:", item);
      if (item.data?.source === "panel-control") {
        // Lógica específica para sincronizaciones desde matriz
        if (item.sala === "ticketsEmitidos") {
          init();
          toast.success("Sincronización recibida desde matriz");
        } else if (item.sala === "ticketPeriodos") {
          // Actualizar periodos inmediatamente
          handleGetPeriodo();
          toast.success("Periodos actualizados desde matriz");
        }
      } else {
        if (item.sala === "ticketsEmitidos") {
          try {
            const ticket = item.data;

            setdatatickets((prevTickets) => {
              // Buscar si el ticket ya existe
              const ticketIndex = prevTickets.findIndex(
                (t) => t.uuid4 === ticket.uuid4
              );

              if (ticketIndex > -1) {
                // Si existe y es idéntico, no hacer cambios
                if (
                  JSON.stringify(prevTickets[ticketIndex]) ===
                  JSON.stringify(ticket)
                ) {
                  return prevTickets;
                }
                // Actualizar ticket existente
                const newTickets = [...prevTickets];
                newTickets[ticketIndex] = ticket;
                return newTickets;
              }

              // Agregar nuevo ticket al principio del array
              return [ticket, ...prevTickets];
            });
          } catch (error) {
            console.error("Error procesando actualización:", error);
          }
        } else if (item.sala === "ticketPeriodos") {
          handleGetPeriodo();
        }
      }
    };

    socket.emit("join:ticket", "ticketsEmitidos");
    socket.emit("join:ticket", "ticketPeriodos");
    socket.on("ticket:updated", handleTicketUpdate);
    // Escuchar un evento
    socket.on("reconnect", async (data) => {
      console.log("Server restarted, attempting to reconnect...");
      // Intentar reconectar a las salas
      socket.emit("join:ticket", "ticketsEmitidos");
      socket.emit("join:ticket", "ticketPeriodos");
      // Actualizar la interfaz si es necesario
      setErrorMessage(["El servidor se reinició, reconectando..."]);
      open();
    });

    socket.on("connect", () => {
      socket.emit("join:ticket", "ticketsEmitidos");
      socket.emit("join:ticket", "ticketPeriodos");
    });

    return () => {
      socket.off("connect");
      socket.off("reconnect");
      socket.off("ticket:updated");
      socket.disconnect();
    };
  }, [isOnline, socket]);

  const handleKeyCode = (key) => {
    if (key === "enter") handleGetUser(userCode);
    else if (key === "borrar") setUserCode((prev) => prev.slice(0, -1));
    else setUserCode((prev) => prev + key);
  };

  const handleGetUser = async (userCode) => {
    if (!userCode) {
      setErrorMessage(["Ingrese un código"]);
      open();
      
      return;
    }

    if (!periodoActual) {
      setErrorMessage(["Aun no es hora de comida"]);
      open();
      
      setUserCode("");
      return;
    }

    if (loadingStep1) return;
    setLoadingStep1(true);

    const user = nominausuarios.find(
      (data) => `${data.code}` === `${userCode}`
    );
    if (!user) {
      
      setErrorMessage(["Código no válido"]);
      open();
      setLoadingStep1(false);
      return;
    }

    const today = moment();
    const isToday = (d) => {
      const birthDate = moment(d, "DD/MM/YYYY");
      return (
        birthDate.date() === today.date() && birthDate.month() === today.month()
      );
    };

    const isBirthday = user.fecha_naci && isToday(user.fecha_naci);

    try {
      const isSpecialCode = ["V001", "E001", "G001", "P001", "X001"].includes(
        userCode
      );
      const newticket = {
        pre_usuario_id: user.pre_usuario_id,
        pre_comida_id: periodoActual.pre_comida_id,
        pre_periodo_id: periodoActual.pre_periodo_id,
        create_at: dateLocal(),
        uuid4: uuidv5(
          `${user.pre_usuario_id}-${
            periodoActual.pre_comida_id
          }-${dayjs().format("YYYYMMDD")}${
            isSpecialCode ? `-${Date.now()}` : ""
          }`,
          UUID_NAMESPACE
        ),
      };

      const hasDuplicate =
        !isSpecialCode &&
        datatickets.some(
          (t) =>
            t.pre_usuario_id === newticket.pre_usuario_id &&
            t.pre_comida_id === newticket.pre_comida_id
        );

      if (hasDuplicate) {
        
        setErrorMessage([`Ya separó ${periodoActual.pre_comidas.nombre}`]);
        open();
        setUserCode("");
        setUser(null);
        setLoadingStep1(false);
        return;
      }

      // Crear ticket directamente en la API
      const res = await ApiCrearTicket(newticket);

      if (res.sms === "ok" || res.code === "limitcomidauser") {
        setUser(user);
        
        setShowModal(true);
        if (isBirthday) {
          setBirthday((prev) => [...prev, user.nombres]);
        }

        const dataSend = {
          ...res.data,
          user: {
            nombres: user.nombres,
            apellidos: user.apellidos,
            code: user.code,
            fecha_naci: user.fecha_naci,
          },
        };

        // Emitir actualización en tiempo real
        socket.emit("ticket:update", {
          sala: "ticketsEmitidos",
          data: dataSend,
        });
      } else {
        throw new Error(res.sms || "Error al crear ticket");
      }
    } catch (error) {
      
      setErrorMessage([error.message]);
    } finally {
      // Actualizar lista de tickets
      await init();

      if (isBirthday) {
        setTimeout(() => {
          setLoadingStep1(false);
          setBirthday([]);
        }, 3000);
        setTimeout(() => {
          setShowModal(false);
          setUser(null);
          setUserCode("");
          document.getElementById("borrar").click();
        }, 800);
      } else {
        setLoadingStep1(false);
        setTimeout(() => {
          setShowModal(false);
          setUser(null);
          setUserCode("");
          setBirthday([]);
          document.getElementById("borrar").click();
        }, 800);
      }
    }
  };

  const init = async () => {
    const currentPeriod = getPeriodoActual();
    const inicio = dayjs().format("DD-MM-YYYY");
    const fin = dayjs().format("DD-MM-YYYY");
    const resTotal = await ApiGetTotalTicketWithDates(inicio, fin);
    let totaldata = [];

    if (resTotal.data > 0) {
      const totalPaginas = Math.ceil(resTotal.data / 600);

      for (let x = 1; x <= totalPaginas; x++) {
        const res = await ApiGetAllTicketsWithDate(inicio, fin, x, 600);
        if (res.sms === "ok") totaldata = totaldata.concat(res.data.tickets);
      }

      if (totaldata.length > 0) {
        totaldata = totaldata.filter(
          (data) =>
            data?.pre_comidas?.pre_comida_id ===
            currentPeriod?.pre_comidas?.pre_comida_id
        );
      }
    }
    setdatatickets(totaldata);
  };

  return (
    <>
      {birthday && birthday.length > 0 && (
        <BirthdayFireworksCanvas names={birthday} />
      )}
      <div
        className="position-relative bg-white z-index-1"
        style={{
          transition: "all 4s ease",
          minHeight: showKeyboard ? "" : "800px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div className="bg-white shadow rounded p-3">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              <div
                className="position-relative"
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "15px",
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  boxShadow: "0 4px 15px rgba(99,102,241,0.3)",
                }}
              >
                <span
                  className="position-absolute top-50 start-50 translate-middle text-white fw-bold"
                  style={{ fontSize: "1.8rem" }}
                >
                  {datatickets.length}
                </span>
              </div>

              <div>
                <h3 className="mb-0 text-dark" style={{ fontWeight: 600 }}>
                  Tickets
                  <span
                    className="ms-2"
                    style={{
                      fontSize: "0.9rem",
                      color: isOnline ? "#10b981" : "#ef4444",
                      verticalAlign: "middle",
                    }}
                  >
                    <i
                      className={`fas fa-circle ${
                        isOnline ? "text-success" : "text-danger"
                      }`}
                      style={{
                        fontSize: "0.6rem",
                        animation: "pulse 1.5s infinite",
                        verticalAlign: "2px",
                      }}
                    />
                    {isOnline ? " Conectado" : " Offline"}

                    <span>
                      {socket.connected ? (
                        <label>
                          <FaPlug color="green" />
                          Socket
                        </label>
                      ) : (
                        <label>
                          <FaPlug color="red" />
                          Socket
                        </label>
                      )}
                    </span>
                  </span>
                </h3>
                <div className="d-flex w-100 justify-content-between align-items-center">
                  <>
                    {periodoActual ? (
                      <>
                        {periodoActual.pre_comidas && (
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {periodoActual.pre_comidas.nombre} /// ( Inicio:
                            {periodoActual.pre_comidas.hora_inicio} - Fin:{" "}
                            {periodoActual.pre_comidas.hora_fin})
                          </div>
                        )}
                      </>
                    ) : (
                      <div
                        style={{
                          borderRadius: 8,
                          padding: "6px 12px",
                          fontSize: "14px",
                          backgroundColor: "#f9fc59",
                          color: "#c62828",
                          border: "1px solid #ef9a9a",
                        }}
                      >
                        Aun no es hora de comida
                      </div>
                    )}
                  </>
                </div>
                <DateHourSecondCounter timer={timer} setTimer={setTimer} />
              </div>
            </div>
            <div className="d-flex flex-column align-items-center gap-3">
              <div>
                <button
                  onClick={() => handleGetNomina()}
                  className="mx-1 px-1"
                  style={
                    nominausuarios
                      ? {
                          background: "green",
                          color: "white",
                          borderRadius: "15px",
                        }
                      : {
                          background: "black",
                          color: "white",
                          borderRadius: "15px",
                        }
                  }
                >
                  Nómina Sync ({nominausuarios.length})
                </button>
                <button
                  onClick={() => handleGetPeriodo()}
                  className="mx-1 px-1"
                  style={
                    periodo
                      ? {
                          background: "green",
                          color: "white",
                          borderRadius: "15px",
                        }
                      : {
                          background: "black",
                          color: "white",
                          borderRadius: "15px",
                        }
                  }
                >
                  Periodo Sync
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={init}
                  className="btn btn-sm px-3 py-2 rounded-pill"
                  style={{
                    background: "#f9fc59",
                    color: "#4f46e5",
                    fontWeight: 500,
                    transition: "all 0.2s",
                  }}
                >
                  <i className="fas fa-sync me-2" />
                  tickets
                </button>
                <button
                  onClick={() => setShowKeyboard(!showKeyboard)}
                  className="btn btn-sm px-3 py-2 rounded-pill"
                  style={{
                    background: showKeyboard ? "#e0e7ff" : "#f3f4f6",
                    color: "#4f46e5",
                    fontWeight: 500,
                    transition: "all 0.2s",
                  }}
                >
                  <i
                    className={`fas fa-${
                      showKeyboard ? "eye-slash" : "keyboard"
                    } me-2`}
                  />
                  {showKeyboard ? "Ocultar teclado" : "Mostrar teclado"}
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center flex-grow-1">
            <div className="w-100 d-flex flex-column">
              <div className="d-flex justify-content-center align-items-center gap-2">
                <input
                  style={{
                    background: "#d7d7d7",
                    color: "black",
                    fontWeight: "bold",
                    width: "100%",
                    height: "55px",
                    fontSize: "55px",
                    borderRadius: "15px",
                    border: "none",
                  }}
                  type="idCode"
                  id="idcode"
                  ref={inputRef}
                  inputMode="none"
                  value={userCode}
                  //withAsterisk
                  onChange={(e) => {
                    if (e.target.value.includes(" ")) {
                      const parts = e.target.value.split(" ");
                      if (parts.length > 1) {
                        const c = parts[1];
                        handleGetUser(c);
                      }
                    } else {
                      if (e.target.value.length > 0) {
                        handleGetUser(e.target.value);
                      } else {
                        setUserCode(e.target.value);
                      }
                    }
                    /* setUserCode(e.target.value);
                    setScannedResult(e.target.value); */
                  }}
                  className=" text-center p-5"
                />
              </div>
              <section style={{ display: showKeyboard ? "block" : "none" }}>
                <div className="flex-grow-1 d-flex align-items-stretch">
                  <Button
                    mt={10}
                    variant="filled"
                    color="red"
                    id="borrar"
                    onClick={() => {
                      //setUserCode((prev) => prev.slice(0, -1));
                      setUserCode("");
                      inputRef.current.focus();
                    }}
                    style={{
                      marginRight: "10px",
                      width: "40%",
                      height: "50px",
                      borderRadius: "15px",
                    }}
                  >
                    <h1> Borrar</h1>
                  </Button>
                  <Button
                    disabled={loadingStep1 || !periodoActual ? true : false}
                    mt={10}
                    variant="filled"
                    color="teal"
                    onClick={() => {
                      handleGetUser(userCode);
                    }}
                    h={50}
                    style={{
                      width: "60%",
                      borderRadius: "15px",
                      height: "50px",
                    }}
                    className="shadow"
                  >
                    {/*                       <i className="fas fa-check" style={{ fontSize: '1.9rem' }} />

 */}
                    <h1> {!loadingStep1 ? "Ok" : "Espere ..."}</h1>
                  </Button>
                </div>
                <hr />

                <div className="flex-grow-1 d-flex align-items-start justify-content-center gap-2">
                  {loadingStep1 ? <h3>VERIFICANDO CÓDIGO...</h3> : null}
                </div>

                <NumericKeyboard
                  onKeyClick={handleKeyCode}
                  hideControls={true}
                />

                <hr />
                <div className=" d-flex align-items-start justify-content-center ">
                  <Button
                    size="xl"
                    variant="default"
                    onClick={() => {
                      setUserCode((prev) => prev + "V");
                    }}
                    h={80}
                    w={80}
                    style={{
                      borderColor: "#6991cc",
                    }}
                    className="px-2 mx-2"
                  >
                    <span
                      style={{
                        fontSize: "1.9rem",
                      }}
                    >
                      V
                    </span>
                  </Button>
                  <Button
                    size="xl"
                    variant="default"
                    onClick={() => {
                      setUserCode((prev) => prev + "P");
                    }}
                    h={80}
                    w={80}
                    style={{
                      borderColor: "#6991cc",
                    }}
                    className="px-2 mx-2"
                  >
                    <span
                      style={{
                        fontSize: "1.9rem",
                      }}
                    >
                      P
                    </span>
                  </Button>
                  <Button
                    size="xl"
                    variant="default"
                    onClick={() => {
                      setUserCode((prev) => prev + "E");
                    }}
                    h={80}
                    w={80}
                    style={{
                      borderColor: "#6991cc",
                    }}
                    className="px-2 mx-2"
                  >
                    <span
                      style={{
                        fontSize: "1.9rem",
                      }}
                    >
                      E
                    </span>
                  </Button>
                  <Button
                    size="xl"
                    variant="default"
                    onClick={() => {
                      setUserCode((prev) => prev + "G");
                    }}
                    h={80}
                    w={80}
                    style={{
                      borderColor: "#6991cc",
                    }}
                    className="px-2 mx-2"
                  >
                    <span
                      style={{
                        fontSize: "1.9rem",
                      }}
                    >
                      G
                    </span>
                  </Button>
                  <Button
                    size="xl"
                    variant="default"
                    onClick={() => {
                      setUserCode((prev) => prev + "X");
                    }}
                    h={80}
                    w={80}
                    style={{
                      borderColor: "#6991cc",
                    }}
                    className="px-2 mx-2"
                  >
                    <span
                      style={{
                        fontSize: "1.9rem",
                      }}
                    >
                      X
                    </span>
                  </Button>
                </div>
              </section>
              {/*  <Scanner
                  
                    onScan={(result) => {
                      aux(result[0].rawValue);
                    }}
                  /> */}

              {/*  <QrReader
                    onScanSuccess={onScanSuccess}
                    onScanFail={onScanFail}
                    scannedResult={scannedResult}
                  /> */}
            </div>
          </div>
        </div>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          {user ? (
            <div className="w-100 d-flex justify-content-center align-items-center flex-column">
              <div
                className="p-3 my-4"
                style={{ backgroundColor: "black", borderRadius: "30px" }}
              >
                {" "}
                <i
                  className="fas fa-user"
                  style={{ fontSize: "30px", color: "white" }}
                ></i>{" "}
              </div>
              <label htmlFor="" style={{ fontSize: "25px" }}>
                {" "}
                {user.nombres} {user.apellidos}
              </label>
              <label htmlFor="" style={{ fontSize: "25px" }}>
                CÓDIGO :{" "}
                <strong style={{ fontSize: "25px" }}>{user.code}</strong>
              </label>
              <div>
                <img
                  src={imagecheck}
                  alt=""
                  style={{ width: "250px", height: "250px" }}
                />
              </div>
            </div>
          ) : (
            "no hay user seleccionado"
          )}
        </ModalDefault>
      </div>
    </>
  );
};

export const DateHourSecondCounter = ({ setTimer, timer }) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="d-flex pt-2 pb-2">
      <Badge
        color="teal"
        variant="filled"
        style={{ fontSize: "1.2rem" }}
        mr={5}
      >
        {dayjs(timer).format("DD-MM-YYYY")}
      </Badge>
      <Badge color="teal" variant="filled" style={{ fontSize: "1.2rem" }}>
        {timer?.getHours()}:{timer?.getMinutes()}:{timer?.getSeconds()}
      </Badge>
    </div>
  );
};

export default SteperTickets;
